<template>
  <a-modal :destroyOnClose="true"
  :mask-closable="false"
  style="top: 180px;"
  width="700px"
  v-model="visible"
  :title="record.id == null ? $t('添加部门') : $t('编辑部门')">
      <div slot="footer">
          <a-button :loading="loading" @click="handleCancel" style="background-color: #ffffff; color: #000; font-size: 14px; height: 32px; border: 1px solid #DEE0E3;">{{ $t('取消') }}</a-button>
          <a-button :loading="loading" @click="handleSave" style="background-color: #2F88F8; color: #ffffff; font-size: 14px; height: 32px; border: none;">{{ $t('确定') }}</a-button>
      </div>
      <a-form :form="form" layout="vertical" style="margin-top: 0px;">
        <a-form-item :label="$t('所属应用')">
          <a-select :placeholder="$t('请选择')" v-decorator="['appId', { initialValue: record.appId, rules: [{ required: false, message: $t('请选择') }] }]" :options="appOptions" />
        </a-form-item>
        <a-form-item :label="$t('部门名称')">
          <a-input :placeholder="$t('请输入')" v-decorator="['name', { initialValue: record.name, rules: [{ required: true, message: $t('请输入') }] }]" />
        </a-form-item>
        <a-form-item :label="$t('部门编码')">
          <a-input :placeholder="$t('请输入')" v-decorator="['code', { initialValue: record.code, rules: [{ required: false, message: $t('请输入') }] }]" />
        </a-form-item>
        <a-form-item :label="$t('上级部门')">
          <a-tree-select :dropdownStyle="{maxHeight: '300px'}" :tree-data="treeData" :placeholder="$t('请选择')" v-decorator="['parentId', { initialValue: record.parentId }]" />
        </a-form-item>
        <a-form-item :label="$t('备注')">
          <a-textarea v-decorator="['remark', { initialValue: record.remark }]" />
        </a-form-item>
      </a-form>
  </a-modal>  
</template>
<script>
import { buildDepartTree } from '../config/DeptConfigs'
import { getDeptList, saveDept } from '@/api/system/dept'
import { getAppListForCurrentUser } from '@/api/app/app'

export default {
  data () {
      return {
          form: this.$form.createForm(this),
          record: {},
          appOptions: [],
          visible: false,
          treeData: [],
          loading: false,
      }
  },
  methods: {
      show (record) {
          this.record = Object.assign({}, record)
          this.prepareData()
          this.visible = true
      },
      prepareData () {
          this.treeData = []
          this.form.resetFields()
          this.loadDeparts()
          this.loadOptions()
      },
      loadOptions() {
        getAppListForCurrentUser().then(res => {
          this.appOptions = res.data?.map(e => ({ label: e.name, value: e.id })) ?? []
        })
      },
      loadDeparts () {
          this.loading = true
          getDeptList().then(res => {
              let result = res
              if (res.code === 0 && res.data != null && res.data.length > 0) {
                  const rows = res.data.map(item => {
                      return {
                          id: item.id,
                          parentId: item.parentId,
                          key: item.id,
                          value: item.id,
                          title: item.name
                      }
                  })
                  const treeData = buildDepartTree(rows)
                  this.removeDataFromTreeData(treeData, this.record.id)
                  this.treeData = treeData
              }
          }).catch (err => {
              
          }).finally(() => {
              this.loading = false
          })
      },
      removeDataFromTreeData (treeData, removeId) {
          if (removeId == null || treeData == null) {
              return treeData
          }
          for (let node of treeData) {
              if (node.id == removeId) {
                  treeData.splice(treeData.indexOf(node), 1)
              } else if (node.children != null){
                  this.removeDataFromTreeData(node.children, removeId)
              }
          }
      },
      handleCancel () {
          this.visible = false
      },
      handleSave (e) {
          e.preventDefault()
          this.form.validateFields((err, value) => {
              if (err != null) {
                  return
              }
              const params = Object.assign({ id: this.record.id }, value)
              this.loading = true
              saveDept(params).then(res => {
                  if (res.code === 0) {
                      this.$message.success(this.$t('保存成功'))
                      this.$emit('ok')
                      this.visible = false
                  } else {
                      this.$message.error(res.msg || this.$t('保存失败'))
                  }
              }).catch (err => {
                  const data = err.response.data
                  this.$message.error(data.msg || this.$t('保存失败'))
              }).finally (() => {
                  this.loading = false
              })
          })
      },
  },
}
</script>
